import TableGameBetCell from '@/components/core/Table/CustomCells/TableGameBetCell';
import TableUser from '@/components/core/Table/CustomCells/TableUser';
import { DetailedBet } from '@/models/detailed-bet';
import { Player } from '@/models/player';
import { Decimal } from '@starsoft/common/services/Decimal';
import { TableGridColumn } from '@starsoft/common/src/components/TableGrid/props';

export const scoreboardBets: TableGridColumn<any>[] = [
  {
    field: 'player.username',
    headerName: 'tab_username',
    renderCell: bet => <TableUser player={bet?.player as Player} />,
  },

  {
    field: 'amount',
    headerName: 'table_invite_header_bet_amount',
    renderCell: (bet: DetailedBet) => <TableGameBetCell bet={bet} showAmount />,
  },
  {
    field: 'crashpointBet.crashpoint',
    headerName: 'tab_multiplier',
    valueFormatter: bet =>
      `${Decimal.fromSubunits(bet?.multiplier, {
        scale: 4,
      }).toNumberString()}x`,
  },
  {
    field: 'payout',
    headerName: 'table_game_win',
    renderCell: (bet: DetailedBet) => (
      <TableGameBetCell bet={bet} isProfitStyle />
    ),
  },
];
